import {useEffect} from 'react';
import brandIdEmitter from '@/utils/brandIdEventEmitter';
import isUuidFormat from '@/utils/isUuidFormat';
import useParams from '@/hooks/use-params';

function useBrandId() {
  const {brandId} = useParams();

  const validatedBrandId = isUuidFormat(brandId) ? brandId : null;
  useEffect(() => {
    if (validatedBrandId) {
      brandIdEmitter.updateBrandId(brandId);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [validatedBrandId]);
  return validatedBrandId;
}

export default useBrandId;
